import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=5c7043d4&"
import script from "./CustomFields.vue?vue&type=script&lang=js&"
export * from "./CustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7043d4')) {
      api.createRecord('5c7043d4', component.options)
    } else {
      api.reload('5c7043d4', component.options)
    }
    module.hot.accept("./CustomFields.vue?vue&type=template&id=5c7043d4&", function () {
      api.rerender('5c7043d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/CustomFields.vue"
export default component.exports